<template>
    <!--
    date:2021-12-09
    description:打印设置页面
    -->
    <div class="printPage">
        <!-- <Left :leftArray='leftArray'/> -->
        <section class="left_content">
            <div class="left_header">
                <el-input :placeholder="$t('public.please_enter')" style="width: 60%;" v-model="searchValue" clearable></el-input>
                <el-button type="primary" icon="el-icon-search" circle @click="searchFn"></el-button>
                <el-button type="primary" icon="el-icon-circle-plus-outline" circle @click="addFn"></el-button>
            </div>
            <div class="left_text">{{ $t('integration.print_grouping') }}</div>
            <div class="left_main">
                <ul>
                    <li :class="acitcve === index ? 'active' : ''" v-for="(item, index) in leftArray" :key="index">
                        <span @click="handleClick(item, index)" :title="item.groupName">{{ item.groupName }}</span>
                        <i class="el-icon-delete" @click="deleteFn(item)"></i>
                    </li>
                </ul>
            </div>
        </section>
        <section v-show="isRightContent" class="right_content">
            <div class="right_header">
                <el-input :placeholder="$t('public.please_enter')" style="width: 250px;" v-model="editValue.groupName" maxlength="30" @blur="editBlur" clearable></el-input>
                <el-button type="primary" @click="saveAllFn">{{ $t('public.save') }}</el-button>
            </div>
            <div class="right_main">
                <transition name="left-fade">
                    <section class="main_left" v-show="!isShow">
                        <div class="main_left_header">
                            <i class="el-icon-s-fold" @click="isShow = true"></i>
                            <el-input :placeholder="$t('public.please_enter')" style="width: 220px;" v-model="filterText" clearable></el-input>
                        </div>
                        <div class="main_left_tree">
                            <el-tree
                                class="tree ztree"
                                ref="tree"
                                :data="treeData"
                                show-checkbox
                                node-key="sensorId"
                                :props="defaultProps"
                                :filter-node-method="filterNode"
                                :render-content="renderContent"
                                :default-expanded-keys="defaultKey"
                                :default-checked-keys="defaultKey"
                                :default-expand-all="defaultAll"
                                @check="checkChangeFn"
                            ></el-tree>
                        </div>
                    </section>
                </transition>
                <section class="main_right">
                    <div class="main_data">
                        <div class="main_right_header">
                            <i v-show="isShow" class="el-icon-s-unfold" @click="isShow = false"></i>
                            <h1>{{ $t('integration.data_collection_time_setting') }}</h1>
                        </div>
                        <div class="main_data_content">
                            <el-form ref="formData" :model="formData" :rules="rules" label-width="90px">
                                <template v-if="formData.collectType === '0'">
                                    <el-form-item :label="$t('integration.print')" prop="collectDay">
                                        <el-input v-model="formData.collectDay" style="width:100px;margin-right:15px;"></el-input>
                                        <el-select v-model="formData.collectType" style="width:80px;">
                                            <el-option :label="$t('integration.day')" value="0"></el-option>
                                            <el-option :label="$t('integration.month')" value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                                <template v-else>
                                    <el-form-item :label="$t('integration.print')" prop="collectMonth">
                                        <el-input v-model="formData.collectMonth" style="width:100px;margin-right:15px;"></el-input>
                                        <el-select v-model="formData.collectType" style="width:80px;">
                                            <el-option :label="$t('integration.day')" value="0"></el-option>
                                            <el-option :label="$t('integration.month')" value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                                <el-form-item :label="$t('integration.time_selection')">
                                    <section class="data_chooze_time">
                                        <div class="data_time">
                                            <section v-for="(item, index) in collectTimes" :key="index">
                                                <el-time-picker
                                                    style="width:190px;height:36px;"
                                                    is-range
                                                    value-format="HH:mm:ss"
                                                    v-model="item.time"
                                                    :range-separator="$t('public.to')"
                                                    :start-placeholder="$t('public.start_time')"
                                                    :end-placeholder="$t('public.end_time')"
                                                    :placeholder="$t('integration.select_a_time_range')"
                                                ></el-time-picker>
                                                <span @click="deleteTime(index)">X</span>
                                            </section>
                                        </div>
                                        <span class="data_add" @click="handeClickAdd">+</span>
                                    </section>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="main_time">
                        <div class="main_right_header">
                            <h1>{{ $t('integration.print_settings') }}</h1>
                        </div>
                        <div class="main_time_content">
                            <el-form ref="formSetData" :model="formSetData" :rules="rules" label-width="90px">
                                <el-form-item :label="$t('integration.stay')" prop="printType">
                                    <el-select v-model="formSetData.printType">
                                        <el-option v-for="item in print_list" :key="item.value" :label="$t(item.label)" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('integration.time_selection')">
                                    <section class="data_chooze_time">
                                        <div class="data_time">
                                            <section v-for="(item, key) in printTimes" :key="key">
                                                <el-time-picker
                                                    style="width:180px;height:36px;"
                                                    v-model="item.time"
                                                    :picker-options="{
                                                        selectableRange: '00:00:00 - 23:59:59'
                                                    }"
                                                    value-format="HH:mm:ss"
                                                    :placeholder="$t('integration.any_point_in_time')"
                                                ></el-time-picker>
                                                <span @click="deleteTimeSet(key)">X</span>
                                            </section>
                                        </div>
                                        <span class="data_add" @click="handeClickAddSet">+</span>
                                    </section>
                                </el-form-item>
                                <el-form-item :label="$t('integration.use_printer')">
                                    <section class="data_chooze_time">
                                        <div class="data_time">
                                            <section v-for="(item, k) in printList" :key="k">
                                                <span class="print_span">{{ item.printerName }}</span>
                                                <span @click="deletePrint(k)">X</span>
                                            </section>
                                        </div>
                                        <span class="data_add" @click="addPrint">+</span>
                                    </section>
                                </el-form-item>
                                <span style="font-size:14px;margin-left:15px">{{ $t('integration.print_data') }}</span>
                            </el-form>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <Modal :title="DialogTitle" :visible.sync="isShowDialog" :width="DialogWidth">
            <el-form :inline="true" :model="formInline" ref="formInline" :rules="rules" class="demo-form-inline" label-width="100px">
                <el-form-item :label="$t('integration.group_name')" prop="groupName">
                    <el-input v-model="formInline.groupName" @blur="blurFn" maxlength="30" :placeholder="$t('integration.please_enter_the_group_name')"></el-input>
                    <div v-if="isShowMsg" class="el-form-item__error">{{ $t('integration.the_group_name_already_exists') }}</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="isShowDialog = false">{{ $t('public.cancel') }}</el-button>
                <el-button type="primary" @click="saveFn">{{ $t('public.save') }}</el-button>
            </div>
        </Modal>
        <!-- 打印机集合 -->
        <Modal :title="DialogTitle" :visible.sync="isShowDialog2" :width="DialogWidth2">
            <el-transfer
                filterable
                @mouseover.native="addTtile"
                :titles="['未选择列表', '已选择列表']"
                :button-texts="['到左边', '到右边']"
                :props="{
                    key: 'printerId',
                    label: 'printerName'
                }"
                filter-:placeholder="$t('public.please_enter')"
                v-model="printIds"
                :data="dataList"
            ></el-transfer>
            <div slot="footer">
                <el-button type="primary" @click="isShowDialog2 = false">{{ $t('public.cancel') }}</el-button>
                <el-button type="primary" @click="saveFnPrint">{{ $t('public.save') }}</el-button>
            </div>
        </Modal>
    </div>
</template>

<script>
let oddzeno = function(rules, value, cb) {
    let odd = /^(0|([1-9]\d*))$/;
    if (!odd.test(value)) {
        cb($t('integration.please_enter_a_positive_integer_greater_than_0'));
    } else {
        cb();
    }
};
// import Left from './children/Left.vue'
import { printGroupList, printGroupDelete, printAddGroup, printGroupInfo, printGroupSave, rolerighttree, printInfo, checkPrintGroup, updateGroupName } from '@/api/api.js';
export default {
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    // components:{
    //     Left
    // },
    computed: {
        rules() {
            return {
                collectDay: [
                    { required: true, message: $t('integration.data_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: oddzeno,
                        trigger: 'blur'
                    }
                ],
                collectMonth: [
                    { required: true, message: $t('integration.data_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: oddzeno,
                        trigger: 'blur'
                    }
                ],
                groupName: [{ required: true, message: $t('integration.group_name_cannot_be_empty'), trigger: 'blur' }],
                printType: [{ required: true, message: $t('integration.data_cannot_be_empty'), trigger: 'change' }]
            };
        }
    },
    data() {
        return {
            searchValue: '',
            isShowDialog: false,
            isShowDialog2: false,
            DialogWidth: '400px',
            DialogWidth2: '800px',
            DialogTitle: '',
            formInline: {
                groupName: ''
            },
            editValue: {},
            dataList: [],
            /**打印机id集合 */
            printIds: [],
            printList: [],
            dialogValue: '',
            leftArray: [],
            acitcve: null,
            treeData: [],
            defaultProps: {
                label: 'label',
                children: 'item',
                disabled: 'isDel'
            },
            isShow: false,
            filterText: '',
            formData: {
                collectDay: '',
                collectType: '0'
            },
            /**打印设置时间集合 */
            print_list: [
                {
                    value: 0,
                    label: $t('integration.every_day')
                },
                {
                    value: 1,
                    label: $t('integration.the_first_day_of_each_week')
                },
                {
                    value: 2,
                    label: $t('integration.last_day_of_the_week')
                },
                {
                    value: 3,
                    label: $t('integration.the_first_day_of_each_month')
                },
                {
                    value: 4,
                    label: $t('integration.last_day_of_each_month')
                },
                {
                    value: 5,
                    label: $t('integration.first_day_of_each_quarter')
                },
                {
                    value: 6,
                    label: $t('integration.last_day_of_each_quarter')
                },
                {
                    value: 7,
                    label: $t('integration.the_first_day_of_each_year')
                },
                {
                    value: 8,
                    label: $t('integration.last_day_of_each_year')
                },
                {
                    value: 9,
                    label: $t('integration.print_every_two_minutes')
                }
            ],
            formSetData: {
                printType: ''
            },
            /** 数据采集时间设置数组 */
            collectTimes: [
                {
                    time: ['00:00:00', '23:59:59']
                }
            ],
            /**数据打印设置时间 */
            printTimes: [{ time: '00:00:00' }],
            /** 树形数据的构建 */
            groupDevices: [],
            flagTree: true, //标识当点击保存时候是否存在有载体没有传感器绑定的情况
            defaultExpandedKey: [],
            defaultKey: [], //默认选中//默认展开
            defaultAll: false,
            /** 编辑时候的数据 */
            editObj: {},
            /** 右侧数据的隐藏 */
            isRightContent: false,
            /** 校验分组唯一性验证信息 */
            isShowMsg: false
        };
    },
    mounted() {
        this.httpFn();
        this.initTree();
        this.printGroupInfoFn();
        console.log(this.$store.getters);
    },
    methods: {
        /** 初始化tree 不去动之前的树的数据 */
        initTree() {
            let initObj = {
                sync: true,
                type: 1,
                userId: this.$store.getters.userInfo.user.id,
                loadCarrier: true,
                isAddAllNode: true,
                loadSensor: true,
                isAddAllNode: false
            };
            rolerighttree(initObj).then(res => {
                this.treeData = this.TOODSETVAL(res.result.item);
            });
        },
        /**给传感器赋予顶级范围 */
        TOODSETVAL(arrayTree) {
            arrayTree.forEach(opt => {
                opt.carrierId && opt.item.length > 0
                    ? opt.item.forEach(arg => {
                          this.$set(arg, 'scopeId', opt.scopeId);
                          return;
                      })
                    : this.TOODSETVAL(opt.item);
            });
            return arrayTree;
        },
        /** 初始获取数据*/
        httpFn(param = {}) {
            printGroupList(param).then(res => {
                if (res.state.code === 200) {
                    this.leftArray = res.result;
                }
            });
        },
        /** 查询左侧 */
        searchFn() {
            this.httpFn({ groupName: this.searchValue });
        },
        /** 添加分组 */
        addFn() {
            this.isShowMsg = false;
            this.isShowDialog = true;
            this.DialogTitle = $t('integration.newly_added');
            this.$nextTick(() => {
                if (this.$refs.formInline) {
                    this.$refs.formInline.resetFields();
                }
            });
        },
        /** 删除分组 */
        deleteFn(item) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'))
                .then(() => {
                    printGroupDelete({ groupId: item.groupId }).then(async res => {
                        await this.$resultHandle(res.state);
                        /** 删除成功 将左侧的高亮取消 同时右侧数据恢复默认 树形取消勾选*/
                        this.acitcve = null;
                        this.defaultData();
                        this.defaultKey = [];
                        this.httpFn();
                        this.initTree();
                        this.isRightContent = false;
                    });
                })
                .catch(() => {});
        },
        /** 保存分组 */
        saveFn() {
            if (this.isShowMsg) return;
            this.$refs.formInline.validate(vail => {
                if (vail) {
                    printAddGroup(this.formInline).then(async res => {
                        await this.$resultHandle(state);

                        this.isShowDialog = false;

                        this.httpFn();
                    });
                }
            });
        },
        /**
         * 左侧点击
         * 显示右侧
         * 高亮当前点击
         * 赋值
         * 清空树形勾选
         * 获取右侧数据
         *  */
        handleClick(row, index) {
            this.isRightContent = true;
            this.acitcve = index;
            this.editValue = { ...row };
            this.printInfoFn(row);
        },
        /** 获取右侧信息 */
        printInfoFn(row) {
            this.$refs.tree.setCheckedKeys([]);
            this.defaultKey = [];
            printInfo({ groupId: row.groupId }).then(res => {
                if (res.state.code === 200) {
                    /** 清空所有选中的 */
                    this.editObj = { ...res.result };

                    /** 树形的回显 */
                    let groupDevices = res.result.groupDevices;
                    if (groupDevices) {
                        groupDevices.forEach(item => {
                            item.carrierItems.forEach(opt => {
                                this.defaultKey = opt.sensorId.split(',');
                            });
                        });
                        this.$nextTick(() => {
                            this.TOODDISABLED({ scopeId: groupDevices[0].scopeId }, this.treeData);
                        });
                    }

                    /** 表单的回显 */
                    if (Object.keys(res.result.groupSetting).length > 0) {
                        let _obj = res.result.groupSetting;
                        /** 表单 */

                        // this.formData.collectDay = _obj.collectDay || res.result.groupSetting.collectMonth
                        this.formData.collectType = _obj.collectType + '';
                        _obj.collectType === 0 ? (this.formData.collectDay = _obj.collectDay) : (this.formData.collectMonth = _obj.collectMonth);
                        /** 时间 */
                        this.collectTimes = _obj.collectTimes.map(item => {
                            return {
                                time: [item.from, item.to]
                            };
                        });

                        this.printTimes = _obj.printTimes.map(item => {
                            return { time: item };
                        });
                        /** 类型*/
                        this.formSetData.printType = _obj.printType;
                        /** 打印机 */
                        this.printIds = [..._obj.printIds];
                        this.filterFn();
                    } else {
                        /** 默认数据处理 */
                        this.initTree(); // 这个因为树 没有唯一值 做不了 取消勾选 只能重新更新一下数据
                        this.defaultData();
                    }
                }
            });
        },

        // 回复默认值
        defaultData() {
            if (this.$refs.formSetData) {
                this.$refs.formSetData.resetFields();
            }
            this.editObj = {};
            this.formData = {
                collectDay: '',
                collectType: '0'
            };
            this.formSetData = {
                printType: ''
            };
            this.collectTimes = [
                {
                    time: ['00:00:00', '23:59:59']
                }
            ];
            this.printTimes = [{ time: '00:00:00' }];
            this.printList = [];
            //  this.print_ids = []
        },
        /** 递归TOOD 获取所选中的传感器  id */
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },

        /**增加时间选择 */
        handeClickAdd() {
            this.collectTimes.push({
                time: ['00:00:00', '23:59:59']
            });
        },
        /** 时间的删除 */
        deleteTime(index) {
            if (this.collectTimes.length === 1) return this.$message.warning($t('integration.keep_at_least_one_acquisition_time'));
            this.collectTimes.splice(index, 1);
        },
        /**设置打印时间 */
        handeClickAddSet() {
            this.printTimes.push({
                time: '00:00:00'
            });
        },
        /** 打印设置时间的删除 */
        deleteTimeSet(key) {
            if (this.printTimes.length === 1) return this.$message.warning($t('integration.keep_at_least_one_print_setting_time'));
            this.printTimes.splice(key, 1);
        },
        /**打印机添加 */
        addPrint() {
            this.DialogTitle = $t('integration.printer_collection');
            this.isShowDialog2 = true;
            this.printIds = this.printList.map(item => {
                return item.printerId;
            });
        },
        /** 获取打印机数据源 */
        printGroupInfoFn() {
            printGroupInfo().then(res => {
                if (res.state.code === 200) {
                    this.dataList = res.result;
                }
            });
        },

        /** 数据过滤 */
        filterFn() {
            this.printList = this.dataList.filter(item => {
                if (this.printIds.indexOf(item.printerId) > -1) {
                    return item;
                }
            });
        },

        /** 打印机选择保存 */
        saveFnPrint() {
            this.filterFn();
            this.isShowDialog2 = false;
        },
        /** 手动给穿梭框添加title*/
        addTtile(e) {
            const dom = e.target;
            if (dom.title) return;
            dom.title = dom.innerText;
        },
        /** 打印机的删除 */
        deletePrint(key) {
            if (this.printList.length === 1) return this.$message.warning($t('integration.keep_at_least_one_printer'));
            this.printList.splice(key, 1);
            this.printIds.splice(key, 1);
        },
        /** TOOD 递归给传感器添加顶级范围===> 需求改版 注销 */
        // TOODTREE(treeArr, array = this.treeData) {
        //     array.forEach(arg => {
        //         treeArr.forEach(opt => {
        //             if (opt.scene_id === arg.scene_id) {
        //                 this.$set(opt, 'scope_id', arg.scope_id)
        //             } else if (arg.item && arg.item.length > 0) {
        //                 this.TOODTREE(treeArr, arg.item)
        //             } else {
        //                 return
        //             }
        //         })
        //     })
        //     return treeArr
        // },
        /** 保存发送数据 */
        async saveAllFn() {
            /**
             *  一些前端校验
             * 1：校验是否选择了分组
             * 2：校验是否勾选有了树（载体）以及 ==== 取消此校验
             * 2:所选择树的载体是否存在关联传感器
             * 3:校验时间是否选择
             * 4:使用的打印机不能为空
             * 不得不上if else了
             */
            let treeArr = this.$refs.tree
                .getCheckedNodes()
                .concat(this.$refs.tree.getHalfCheckedNodes())
                .filter(item => {
                    return item.sensorId;
                });
            /** 历史原因  后台树结构的数据问题  前端只能这样给传感器set一个顶级范围 需求改版 取消这里的*/
            // let treeArrFlag = this.TOODTREE(treeArr)
            if (Object.keys(this.editValue).length === 0) {
                return this.$message.warning($t('integration.please_select_at_least_one_print_group_information'));
            } else if (treeArr.length === 0) {
                return this.$message.warning($t('integration.please_select_at_least_one_sensor_data'));
            // else if (!this.flagTree) {
            //     return this.$message.warning($t('integration.the_selected_data_has_sensorless_correlation'));
            // } else if (this.printIds.length === 0) {
            //     return this.$message.warning($t('integration.please_select_at_least_one_printer'));
            } else {
                this.collectTimes.some(item => {
                    if (!item.time) return this.$message.warning($t('integration.time_selection_has_empty_time'));
                });
                this.printTimes.some(item => {
                    if (!item.time) return this.$message.warning($t('integration.time_selection_has_empty_time'));
                });
                const justify1 = await this.$refs['formData'].validate().catch(() => {});
                const justify2 = await this.$refs['formSetData'].validate().catch(() => {});
                if (!justify1 || !justify2) return;
                /**  一些前端校验结束*/

                /** 获取分组数据 */
                let { groupId, groupName } = this.editValue;
                /** 针对选择不同的type切换参数 */
                // if (this.formData.collectType !== "0") {
                //     this.$set(this.formData, 'collectMonth', this.formData.collectDay)
                //     delete this.formData.collectDay
                // }
                /** 匹配成后台所需的数据格式*/
                let collectTimes = this.collectTimes.map(item => {
                    return {
                        from: item.time[0],
                        to: item.time[1]
                    };
                });
                /** 匹配成后台所需的数据格式*/
                let printTimes = this.printTimes.map(opt => {
                    return opt.time;
                });
                /** 打印数据整理*/
                let groupSetting = {
                    ...this.formData,
                    ...this.formSetData,
                    collectTimes,
                    printTimes,
                    groupId,
                    printIds: this.printIds
                };
                if (this.editObj.groupSetting && this.editObj.groupSetting.settingsId) {
                    //如果存在这个  则代表是编辑时候的所需要的数据
                    groupSetting.settingsId = this.editObj.groupSetting.settingsId;
                } else {
                    delete groupSetting.settingsId;
                }
                let params = {
                    groupId,
                    // groupName,
                    groupSetting,
                    /** 需求改版 2021 12 29*/
                    scopeId: treeArr[0].scopeId,
                    groupDevices: this.checkFn(treeArr)
                };
                if (params.groupSetting.collectType === '1') {
                    delete params.groupSetting.collectDay;
                }
                if (params.groupSetting.collectType === '0') {
                    delete params.groupSetting.collectMonth;
                }
                // this.handleClick(this.editValue,this.acitcve)
                printGroupSave(params).then(async res => {
                    if (res.state.code === 200) {
                        this.httpFn();
                        this.handleClick(this.editValue, this.acitcve);
                        await this.$resultHandle(res.state);
                    } else {
                        this.$message.warning(res.state.msg);
                    }
                });
            }
        },
        /** 树形的选中触发 */
        checkFn(checkedKeys) {
            console.log(checkedKeys);
            /** 需求改版  只能选择一个范围下面的 */
            let array = [],
                carrierArray = [],
                sensorTagIds = [],
                sensorId = [],
                groupDevices = [],
                ids = null;
            for (let i = 0; i < checkedKeys.length; i++) {
                /**
                 * 先做范围的判断 范围不一致 则 groupDevices添加多一项
                 * 如果范围一致 那么再判断 载体是否一致
                 * 载体不一致 则 carrierItems 再添加一项
                 * 载体与传感器绑定
                 *
                 * 需求改版12.28 多范围选择更改为单范围选择
                 */
                //
                if (array.indexOf(checkedKeys[i].scopeId) === -1 && carrierArray.indexOf(checkedKeys[i].carrierId) === -1) {
                    array.push(checkedKeys[i].scopeId); //用来标识是否已存在范围
                    carrierArray.push(checkedKeys[i].carrierId); //用来标识是否已存在载体
                    sensorTagIds = checkedKeys[i].label.split(',');
                    sensorId = [checkedKeys[i].sensorId]; //类型问题
                    if (this.editObj && this.editObj.groupDevices) {
                        this.editObj.groupDevices.find(v => {
                            return v.scopeId === checkedKeys[i].scopeId ? (ids = v.id) : (ids = null);
                        });
                    }
                    let carrierItems = [
                        {
                            carrierId: checkedKeys[i].carrierId,
                            sensorTagIds,
                            sensorId
                        }
                    ];
                    let params = {
                        id: ids,
                        scopeId: checkedKeys[i].scopeId,
                        groupId: this.editValue.groupId,
                        carrierItems
                    };
                    groupDevices.push(params);
                } else {
                    groupDevices.forEach(item => {
                        // if (item.scopeId === checkedKeys[i].scopeId) {//相同范围
                        item.carrierItems.forEach(opt => {
                            if (opt.carrierId === checkedKeys[i].carrierId) {
                                //相同载体
                                opt.sensorTagIds.push(checkedKeys[i].label);
                                opt.sensorId.push(checkedKeys[i].sensorId);
                            } else {
                                //不同载体
                                item.carrierItems.push({
                                    carrierId: checkedKeys[i].carrierId,
                                    sensorTagIds: checkedKeys[i].label.split(','),
                                    sensorId: [checkedKeys[i].sensorId]
                                });
                            }
                        });
                        // }
                    });
                }
            }
            /** 清空id为null的时候 以及后台数据的变更*/
            groupDevices = groupDevices.map(item => {
                !item.id ? delete item.id : null;
                item.carrierItems = this.TOODSET(item.carrierItems);
                return item;
            });
            return groupDevices;
        },
        /** 去重 切换数据类型*/
        TOODSET(arr) {
            var obj = {};
            return arr.reduce(function(item, next) {
                next.sensorId = next.sensorId.join(',');
                obj[next.carrierId] ? '' : (obj[next.carrierId] = true && item.push(next));
                return item;
            }, []);
        },
        /** 需求改版 从多个范围选择  ===》 只能选择一个范围 */
        checkChangeFn(row, option) {
            this.TOODDISABLED(row);
        },
        /** 禁止非选择的范围 */
        TOODDISABLED(row, array = this.treeData) {
            if (this.$refs.tree.getCheckedNodes().length === 0) {
                array.forEach(opt => {
                    this.$set(opt, 'isDel', false);
                    if (opt.item) {
                        this.TOODDISABLED(row, opt.item);
                    } else {
                        return;
                    }
                });
            } else {
                array.forEach(opt => {
                    if (opt.level === 0) {
                        // 特殊处理一下第一层
                        opt.scopeId !== row.scopeId ? this.$set(opt, 'isDel', true) : null;
                    }
                    if (opt.item) {
                        opt.scopeId !== row.scopeId ? this.$set(opt, 'isDel', true) : this.$set(opt, 'isDel', false);
                        this.TOODDISABLED(row, opt.item);
                    } else {
                        return;
                    }
                });
            }
        },
        /** 树形的抽离 */
        publicTree(createElement, valueObj, icon) {
            return createElement(
                'span',
                {
                    attrs: {
                        title: valueObj.node.label
                    },
                    class: {
                        textClass: true
                    }
                },
                [
                    createElement('i', {
                        attrs: { class: `iconfont ${icon}` },
                        style: {
                            with: '14px',
                            height: '20px',
                            display: 'inline-block',
                            margin: '0 5px'
                        }
                    }),
                    createElement('span', valueObj.node.label)
                ]
            );
        },
        // 树形控件的图标
        renderContent: function() {
            let createElement = arguments[0];
            let valueObj = arguments[1];
            let nodedata = arguments[1].node.data;
            if (nodedata.level === 0) {
                //等于0说明范围  因为接口没有设置
                return this.publicTree(createElement, valueObj, 'icon-homepage');
            }
            //节点类型 0-设备，1-载体，2-组织(架构)
            else if (nodedata.nodeType === 2) {
                // 下一级直接存在架构
                //nodeType==2时funcType（0-什么都不关联、1-平面图、2-地图）
                switch (nodedata.funcType) {
                    case 0: {
                        return this.publicTree(createElement, valueObj, 'icon-zhunbeiliangchan');
                    }
                    case 1: {
                        return this.publicTree(createElement, valueObj, 'icon-quyu');
                    }
                    case 2: {
                        return this.publicTree(createElement, valueObj, 'icon-ditu');
                    }
                    default:
                        break;
                }
            } else if (nodedata.nodeType === 1) {
                // 下一级直接存在载体
                return this.publicTree(createElement, valueObj, 'icon-shebeishuliang');
            } else if (nodedata.nodeType === 0) {
                // 下一级直接存在传感器
                return this.publicTree(createElement, valueObj, 'icon-chuanganqi1');
            } else {
                // 保留后面可能会添加的
            }
        },
        /** 需求添加 2021 12 29 */
        // 校验分组名称的唯一性
        blurFn() {
            checkPrintGroup({
                groupName: this.formInline.groupName
                // scopeId: this.$store.getters.userInfo.scope.scene_id,
            }).then(res => {
                if (res.state.code === 200) {
                    this.isShowMsg = res.result;
                }
            });
        },
        /** 需求改版 2021 12 30 编辑分组名称  当失去焦点时候修改*/
        editBlur() {
            const { groupId, groupName } = { ...this.editValue };
            updateGroupName({ groupId, groupName }).then(async res => {
                await this.$resultHandle(res.state);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/styles/tree.scss';
.printPage {
    height: 100%;
    display: flex;
    .left_content {
        height: 100%;
        width: 300px;
        box-sizing: border-box;
        border-right: 1px solid var(--primary-color);
        .left_header,
        .left_text {
            height: 60px;
            border-bottom: 1px solid var(--primary-color);
            box-sizing: border-box;
            text-align: center;
            line-height: 60px;
        }
        .left_header {
            .el-button {
                min-width: 36px !important;
            }
            ::v-deep .el-icon-circle-plus-outline {
                color: #fff;
            }
        }
        .left_text {
            font-weight: bold;
            font-size: 22px;
        }
        .left_main {
            height: calc(100% - 120px);
            ul {
                height: 100%;
                overflow: auto;
                scrollbar-width: none; /* firefox */
                -ms-overflow-style: none; /* IE 10+ */
                li {
                    height: 50px;
                    line-height: 50px;
                    padding: 0 15px;
                    border-bottom: 1px solid var(--primary-color);
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &:hover {
                        background-color: var(--primary-color);
                        color: #fff;
                        i {
                            color: #fff;
                        }
                    }
                    span {
                        height: 100%;

                        display: inline-block;
                        flex: 1;
                        font-size: 16px;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    i {
                        font-size: 16px;
                        width: 10%;
                        cursor: pointer;
                        &:hover {
                            color: #e40505;
                        }
                    }
                }
                .active {
                    background-color: var(--primary-color);
                    color: #fff;
                    i {
                        color: #fff;
                    }
                }
            }
            ul::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
        }
    }
    .right_content {
        height: 100%;
        flex: 1;
        .right_header {
            height: 60px;
            padding: 0 15px;
            box-sizing: border-box;
            border-bottom: 1px solid var(--primary-color);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .right_main {
            height: calc(100% - 60px);
            display: flex;
            .main_left {
                width: 300px;
                height: 100%;
                border-right: 1px solid var(--primary-color);
                box-sizing: border-box;
                transition: all 0.5s ease-in-out;
                .main_left_header {
                    height: 60px;
                    padding: 0 15px;
                    border-bottom: 1px solid var(--primary-color);
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    i {
                        font-size: 24px;
                        margin-right: 6px;
                        cursor: pointer;
                    }
                }
                .main_left_tree {
                    height: calc(100% - 60px);
                    overflow: auto;
                    scrollbar-width: none; /* firefox */
                    -ms-overflow-style: none; /* IE 10+ */
                    .ztree {
                        width: 100% !important;
                        ::v-deep .textClass {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            padding-right: 5px;
                            box-sizing: border-box;
                        }
                    }
                }
                .main_left_tree::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                }
            }
            .main_right {
                flex: 1;
                display: flex;
                flex-direction: column;
                .main_data,
                .main_time {
                    flex: 1;
                    border-bottom: 1px solid var(--primary-color);
                    box-sizing: border-box;
                }
                .main_time {
                    flex: 2;
                    border: none;
                }
                .main_right_header {
                    height: 60px;
                    padding: 0 15px;
                    border-bottom: 1px solid var(--primary-color);
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    i {
                        font-size: 24px;
                        margin-right: 6px;
                        cursor: pointer;
                    }
                }
                .main_data_content,
                .main_time_content {
                    height: calc(100% - 60px);
                    padding: 20px 15px;
                    box-sizing: border-box;
                    ::v-deep .el-input__suffix {
                        top: -2px !important;
                    }
                    /**共享样式 */
                    .data_chooze_time {
                        // padding: 5px;
                        display: flex;
                        justify-content: space-between;
                        .data_time {
                            max-height: 200px;
                            width: 98%;
                            overflow: auto;
                            border: 1px solid var(--primary-color);
                            border-radius: 5px 0 0 5px;
                            box-sizing: border-box;
                            display: flex;
                            flex-wrap: wrap;
                            // padding: 2px;
                            section {
                                border: 1px solid var(--primary-color);
                                box-sizing: border-box;
                                border-radius: 5px;
                                margin: 2px;
                            }
                            span {
                                display: inline-block;
                                height: 38px;
                                width: 38px;
                                text-align: center;
                                box-sizing: border-box;
                                border-left: 1px solid var(--primary-color);
                                cursor: pointer;
                                color: red;
                            }
                            .print_span {
                                width: auto;
                                padding: 0 5px;
                                color: var(--primary-color);
                                border-left: none;
                            }
                            ::v-deep .el-input__inner {
                                border: none;
                            }
                        }
                        ::v-deep .el-range-separator {
                            line-height: 26px;
                        }
                        ::v-deep .el-input__icon,
                        .el-range__icon,
                        .el-icon-time {
                            line-height: 28px;
                        }

                        .data_add {
                            display: inline-block;
                            width: 46px;
                            height: 46px;
                            line-height: 44px;
                            text-align: center;
                            border: 1px solid var(--primary-color);
                            border-left: none;
                            border-radius: 0 5px 5px 0;
                            box-sizing: border-box;
                            cursor: pointer;
                            font-size: 22px;
                            color: var(--primary-color);
                        }
                    }
                }
                h1 {
                    font-weight: bold;
                    font-size: 18px;
                }
            }
        }
        .left-fade-enter-active,
        .left-fade-leave-active {
            transition: all 1s;
        }
        .left-fade-enter,
        .left-fade-leave-to {
            opacity: 0;
            transform: translateX(-30px);
        }
        ::v-deep .el-input__suffix {
            top: 2px !important;
        }
        ::v-deep .el-input--mini .el-input__inner {
            border-radius: 5px !important;
        }
    }
}
</style>
